export default Object.freeze([
	{
		label: '[Order #]',
		value: '[Order #]',
		tooltip:
			'<p><b>[Order #]</b><br />Prints the order number</p><p>Example:<br />6773492</p>',
	},
	{
		label: '[Ship Date]',
		value: '[Ship Date]',
		tooltip:
			"<p><b>[Ship Date]</b><br />Prints the order's ship date</p><p>Example:<br />8/30/2017</p>",
	},
	{
		label: '[Order Date]',
		value: '[Order Date]',
		tooltip:
			'<p><b>[Order Date]</b><br />Prints the date the customer placed the order.</p><p>Example:<br />8/28/2017</p>',
	},
	{
		label: '[Sku #1]',
		value: '[Sku #1]',
		tooltip:
			"<p><b>[Sku #1]</b><br />Prints the Item Sku and the quantity for the order's first line item</p><p>Example:<br />4x tee-xl</p>",
	},
	{
		label: '[Sku #2]',
		value: '[Sku #2]',
		tooltip:
			"<p><b>[Sku #2]</b><br />Prints the Item Sku and the quantity for the order's second line item</p><p>Example:<br />5x tee-m</p>",
	},
	{
		label: '[Sku #3]',
		value: '[Sku #3]',
		tooltip:
			"<p><b>[Sku #3]</b><br />Prints the Item Sku and the quantity for the order's third line item</p><p>Example:<br />6x tee-s</p>",
	},
	{
		label: '[Product #1]',
		value: '[Product #1]',
		tooltip:
			"<p><b>[Product #1]</b><br />Prints the Item Name and the quantity for the order's first line item</p><p>Example:<br />4x Hero Tee</p>",
	},
	{
		label: '[Product #2]',
		value: '[Product #2]',
		tooltip:
			"<p><b>[Product #2]</b><br />Prints the Item Name and the quantity for the order's second line item</p><p>Example:<br />5x Hero Tee</p>",
	},
	{
		label: '[Product #3]',
		value: '[Product #3]',
		tooltip:
			"<p><b>[Product #3]</b><br />Prints the Item Name and the quantity for the order's third line item</p><p>Example:<br />6x Hero Tee</p>",
	},
	{
		label: '[Dimensions]',
		value: '[Dimensions]',
		tooltip:
			"<p><b>[Dimensions]</b><br />Prints the order's dimensions in inches</p><p>Example:<br />7.00&#34; x 6.00&#34; x 5.00&#34;</p>",
	},
	{
		label: '[Weight]',
		value: '[Weight]',
		tooltip:
			"<p><b>[Weight]</b><br />Prints the order's weight in pounds and ounces</p><p>Example:<br />0 lbs. 2 oz.</p>",
	},
	{
		label: '[Notes from Customer]',
		value: '[Notes from Customer]',
		tooltip:
			'<p><b>[Notes from Customer]</b><br />Prints the notes from the customer</p>',
	},
	{
		label: '[Warehouse Loc #1]',
		value: '[Warehouse Loc #1]',
		tooltip:
			"<p><b>[Warehouse Loc #1]</b><br />Prints the warehouse location and the quantity for the order's first line item</p><p>Example:<br />4x B7</p>",
	},
	{
		label: '[Warehouse Loc #2]',
		value: '[Warehouse Loc #2]',
		tooltip:
			"<p><b>[Warehouse Loc #2]</b><br />Prints the warehouse location and the quantity for the order's second line item</p><p>Example:<br />5x B8</p>",
	},
	{
		label: '[Warehouse Loc #3]',
		value: '[Warehouse Loc #3]',
		tooltip:
			"<p><b>[Warehouse Loc #3]</b><br />Prints the warehouse location and the quantity for the order's third line item</p><p>Example:<br />6x B9</p>",
	},
]);
